import { memo } from 'react';
import { IAssetIconsProps, IImgProps } from "./Icon.t";

import { ReactComponent as IcAlibaba } from '../../assets/icons/ic_alibaba.svg';
import { ReactComponent as IcAlibabaCircle } from '../../assets/icons/ic_alibaba_circle.svg';
import { ReactComponent as IcAmazon } from '../../assets/icons/ic_amazon.svg';
import { ReactComponent as IcAppStoreBadge } from "../../assets/icons/ic_app_store_badge.svg";
import { ReactComponent as IcApple } from '../../assets/icons/ic_apple.svg';
import { ReactComponent as IcAppleCircle } from '../../assets/icons/ic_apple_circle.svg';
import { ReactComponent as IcArrowLeft } from '../../assets/icons/ic_arrow_left.svg';
import { ReactComponent as IcArrowRight } from '../../assets/icons/ic_arrow_right.svg';
import { ReactComponent as IcArrowRightLeft } from '../../assets/icons/ic_arrow_right_left.svg';
import { ReactComponent as IcAssetDefault } from '../../assets/icons/ic_asset_default.svg';
import { ReactComponent as IcAttention } from "../../assets/icons/ic_attention.svg";
import { ReactComponent as IcAttentionCircleWhite } from "../../assets/icons/ic_attention_circle_white.svg";
import { ReactComponent as IcBack } from "../../assets/icons/ic_back.svg";
import { ReactComponent as IcBank } from '../../assets/icons/ic_bank.svg';
import { ReactComponent as IcBankCard } from '../../assets/icons/ic_bank_card.svg';
import { ReactComponent as IcBankCardArrowRight } from '../../assets/icons/ic_bank_card_arrow_right.svg';
import { ReactComponent as IcBell } from '../../assets/icons/ic_bell.svg';
import { ReactComponent as IcBellFilled } from '../../assets/icons/ic_bell_filled.svg';
import { ReactComponent as IcBellPlus } from '../../assets/icons/ic_bell_plus.svg';
import { ReactComponent as IcBellPlusFilled } from '../../assets/icons/ic_bell_plus_filled.svg';
import { ReactComponent as IcBitcoin } from '../../assets/icons/ic_bitcoin.svg';
import { ReactComponent as IcBnb } from '../../assets/icons/ic_bnb.svg';
import { ReactComponent as IcBonus } from "../../assets/icons/ic_bonus.svg";
import { ReactComponent as IcBonusStub } from "../../assets/icons/ic_bonus_stub.svg";
import { ReactComponent as IcBonusTransaction } from "../../assets/icons/ic_bonus_transaction.svg";
import { ReactComponent as IcBookClosed } from '../../assets/icons/ic_book_closed.svg';
import { ReactComponent as IcBookmark } from '../../assets/icons/ic_bookmark.svg';
import { ReactComponent as IcBookmarkFilled } from '../../assets/icons/ic_bookmark_filled.svg';
import { ReactComponent as IcBrain } from '../../assets/icons/ic_brain.svg';
import { ReactComponent as IcBrent } from '../../assets/icons/ic_brent.svg';
import { ReactComponent as IcBriVa } from "../../assets/icons/ic_bri_va.svg";
import { ReactComponent as IcBtc } from '../../assets/icons/ic_btc.svg';
import { ReactComponent as IcCard } from "../../assets/icons/ic_card.svg";
import { ReactComponent as IcCashback } from '../../assets/icons/ic_cashback.svg';
import { ReactComponent as IcChainLink } from '../../assets/icons/ic_chain_link.svg';
import { ReactComponent as IcChartBars } from "../../assets/icons/ic_chart_bars.svg";
import { ReactComponent as IcChartCandle } from "../../assets/icons/ic_chart_candle.svg";
import { ReactComponent as IcChartColumn } from "../../assets/icons/ic_chart_column.svg";
import { ReactComponent as IcChartLine } from '../../assets/icons/ic_chart_line.svg';
import { ReactComponent as IcChartMountain } from "../../assets/icons/ic_chart_mountain.svg";
import { ReactComponent as IcChartStatistic } from '../../assets/icons/ic_chart_statistic.svg';
import { ReactComponent as IcCheckCircle } from '../../assets/icons/ic_check_circle.svg';
import { ReactComponent as IcCheckCircleBorder } from '../../assets/icons/ic_check_circle_border.svg';
import { ReactComponent as IcCheckCircleThin } from "../../assets/icons/ic_check_circle_thin.svg";
import { ReactComponent as IcCheckMark } from "../../assets/icons/ic_check_mark.svg";
import { ReactComponent as IcCheckMarkCircle } from '../../assets/icons/ic_check_mark_circle.svg';
import { ReactComponent as IcCheckMarkCircleGreen } from '../../assets/icons/ic_check_mark_circle_green.svg';
import { ReactComponent as IcCheckMarkShield } from "../../assets/icons/ic_check_mark_shield.svg";
import { ReactComponent as IcChevronDown } from "../../assets/icons/ic_chevron_down.svg";
import { ReactComponent as IcChevronLeft } from '../../assets/icons/ic_chevron_2_left.svg';
import { ReactComponent as IcChevronRight } from '../../assets/icons/ic_chevron_2_fight.svg';
import { ReactComponent as IcChevronSliderDown } from "../../assets/icons/ic_chevron_slider_down.svg";
import { ReactComponent as IcChevronSliderUp } from "../../assets/icons/ic_chevron_slider_up.svg";
import { ReactComponent as IcCimb } from "../../assets/icons/ic_cimb.svg";
import { ReactComponent as IcCircleSlashed } from "../../assets/icons/ic_circle_slashed.svg";
import { ReactComponent as IcCisco } from '../../assets/icons/ic_cisco.svg';
import { ReactComponent as IcCiscoCircle } from '../../assets/icons/ic_cisco_circle.svg';
import { ReactComponent as IcCiti } from '../../assets/icons/ic_citi.svg';
import { ReactComponent as IcClear } from "../../assets/icons/ic_clear.svg";
import { ReactComponent as IcClock } from '../../assets/icons/ic_clock.svg';
import { ReactComponent as IcClockBlackCircle } from "../../assets/icons/ic_clock_black_circle.svg";
import { ReactComponent as IcClose } from '../../assets/icons/ic_close.svg';
import { ReactComponent as IcClose16 } from '../../assets/icons/ic_close_16.svg';
import { ReactComponent as IcCloseWhite } from '../../assets/icons/ic_close_white.svg';
import { ReactComponent as IcCoinStack } from "../../assets/icons/ic_coin_stack.svg";
import { ReactComponent as IcCoins } from '../../assets/icons/ic_coins.svg';
import { ReactComponent as IcCollapse } from '../../assets/icons/ic_collapse.svg';
import { ReactComponent as IcCollectionCrypto } from "../../assets/icons/ic_collection_crypto.svg";
import { ReactComponent as IcCollectionForex } from "../../assets/icons/ic_collection_forex.svg";
import { ReactComponent as IcCollectionIndices } from "../../assets/icons/ic_collection_indices.svg";
import { ReactComponent as IcCollectionMaterials } from "../../assets/icons/ic_collection_materials.svg";
import { ReactComponent as IcCollectionStocks } from "../../assets/icons/ic_collection_stocks.svg";
import { ReactComponent as IcConnect } from "../../assets/icons/ic_connect.svg";
import { ReactComponent as IcCopy } from "../../assets/icons/ic_copy.svg";
import { ReactComponent as IcCountry } from "../../assets/icons/ic_country.svg";
import { ReactComponent as IcCoupon } from "../../assets/icons/ic_coupon.svg";
import { ReactComponent as IcCrypto } from "../../assets/icons/ic_cryptocurrencies.svg";
import { ReactComponent as IcDana } from "../../assets/icons/ic_dana.svg";
import { ReactComponent as IcDash } from '../../assets/icons/ic_dash.svg';
import { ReactComponent as IcDateRange } from '../../assets/icons/ic_date_range.svg';
import { ReactComponent as IcDelete } from "../../assets/icons/ic_delete.svg";
import { ReactComponent as IcDeleteBasket } from "../../assets/icons/ic_delete_basket.svg";
import { ReactComponent as IcDisconnect } from "../../assets/icons/ic_disconnect.svg";
import { ReactComponent as IcDocCopy } from "../../assets/icons/ic_doc_copy.svg";
import { ReactComponent as IcDocument } from '../../assets/icons/ic_document.svg';
import { ReactComponent as IcDollar } from '../../assets/icons/ic_dollar.svg';
import { ReactComponent as IcDollarRefresh } from "../../assets/icons/ic_dollar_refresh.svg";
import { ReactComponent as IcDot } from "../../assets/icons/ic_dot.svg";
import { ReactComponent as IcDowJones } from '../../assets/icons/ic_dow_jones.svg';
import { ReactComponent as IcDown } from '../../assets/icons/ic_down.svg';
import { ReactComponent as IcDownThin } from '../../assets/icons/ic_down_thin.svg';
import { ReactComponent as IcDownMini } from '../../assets/icons/ic_down_mini.svg';
import { ReactComponent as IcDrawingTools } from "../../assets/icons/ic_drawing_tools.svg";
import { ReactComponent as IcEbay } from '../../assets/icons/ic_ebay.svg';
import { ReactComponent as IcEducation } from '../../assets/icons/ic_education.svg';
import { ReactComponent as IcEmptyPage } from "../../assets/icons/ic_empty_page.svg";
import { ReactComponent as IcEnvelope } from "../../assets/icons/ic_envelope.svg";
import { ReactComponent as IcEnvelopeCheckmark } from "../../assets/icons/ic_envelope_checkmark.svg";
import { ReactComponent as IcEth } from '../../assets/icons/ic_eth.svg';
import { ReactComponent as IcEthereum } from '../../assets/icons/ic_ethereum.svg';
import { ReactComponent as IcExclamationMarkCircle } from "../../assets/icons/ic_exclamation_mark_circle.svg";
import { ReactComponent as IcExclamationMarkTriangle } from "../../assets/icons/ic_exclamation_mark_triangle.svg";
import { ReactComponent as IcExpand } from '../../assets/icons/ic_expand.svg';
import { ReactComponent as IcEyeOff } from '../../assets/icons/ic_eye_off.svg';
import { ReactComponent as IcEyeOn } from '../../assets/icons/ic_eye_on.svg';
import { ReactComponent as IcFacebook } from '../../assets/icons/ic_facebook.svg';
import { ReactComponent as IcFingerprint } from "../../assets/icons/ic_fingerprint.svg";
import { ReactComponent as IcFlags } from "../../assets/icons/ic_flags.svg";
import { ReactComponent as IcFlagsChfUsd } from '../../assets/icons/ic_flags_chf_usd.svg';
import { ReactComponent as IcFlagsEurUsd } from '../../assets/icons/ic_flags_eur_usd.svg';
import { ReactComponent as IcFlagsJpyEur } from '../../assets/icons/ic_flags_jpy_eur.svg';
import { ReactComponent as IcFlagsJpyUsd } from '../../assets/icons/ic_flags_jpy_usd.svg';
import { ReactComponent as IcFlagsUkUsd } from '../../assets/icons/ic_flags_uk_usd.svg';
import { ReactComponent as IcForward } from "../../assets/icons/ic_forward.svg";
import { ReactComponent as IcGas } from '../../assets/icons/ic_gas.svg';
import { ReactComponent as IcGcash } from "../../assets/icons/ic_gcash.svg";
import { ReactComponent as IcGear } from "../../assets/icons/ic_gear.svg";
import { ReactComponent as IcGearApp } from "../../assets/icons/ic_gear_app.svg";
import { ReactComponent as IcGift } from "../../assets/icons/ic_gift.svg";
import { ReactComponent as IcGoPay } from "../../assets/icons/ic_gopay.svg";
import { ReactComponent as IcGold } from '../../assets/icons/ic_gold.svg';
import { ReactComponent as IcGoldCircle } from '../../assets/icons/ic_gold_circle.svg';
import { ReactComponent as IcGoogle } from '../../assets/icons/ic_google.svg';
import { ReactComponent as IcGooglePlayBadge } from "../../assets/icons/ic_google_play_badge.svg";
import { ReactComponent as IcGrabber } from "../../assets/icons/ic_grabber.svg";
import { ReactComponent as IcGraduationCap } from "../../assets/icons/ic_graduation_cap.svg";
import { ReactComponent as IcGrowth } from '../../assets/icons/ic_growth.svg';
import { ReactComponent as IcHarpoonLeftRight } from '../../assets/icons/ic_harpoon_2_left_right.svg';
import { ReactComponent as IcHelpCircle } from '../../assets/icons/ic_help_circle.svg';
import { ReactComponent as IcHistory } from "../../assets/icons/ic_history.svg";
import { ReactComponent as IcHp } from '../../assets/icons/ic_hp.svg';
import { ReactComponent as IcImps } from '../../assets/icons/ic_imps.svg';
import { ReactComponent as IcIndicators } from "../../assets/icons/Ic_indicators.svg";
import { ReactComponent as IcInfinity } from '../../assets/icons/ic_infinity.svg';
import { ReactComponent as IcInfo } from '../../assets/icons/ic_info.svg';
import { ReactComponent as IcInfoCircle } from "../../assets/icons/ic_info_circle.svg";
import { ReactComponent as IcInfoFilled } from "../../assets/icons/ic_info_filled.svg";
import { ReactComponent as IcKoalaIb } from "../../assets/icons/ic_koala_ib.svg";
import { ReactComponent as IcLineTool } from "../../assets/icons/ic_line_tool.svg";
import { ReactComponent as IcLink } from '../../assets/icons/ic_link.svg';
import { ReactComponent as IcLinkaja } from "../../assets/icons/ic_linkaja.svg";
import { ReactComponent as IcLock } from "../../assets/icons/ic_lock.svg";
import { ReactComponent as IcLogoLetter } from '../../assets/icons/ic_logo_letter.svg';
import { ReactComponent as IcLots } from '../../assets/icons/ic_lots.svg';
import { ReactComponent as IcLtc } from '../../assets/icons/ic_ltc.svg';
import { ReactComponent as IcManager } from '../../assets/icons/ic_manager.svg';
import { ReactComponent as IcMandiri } from "../../assets/icons/ic_mandiri.svg";
import { ReactComponent as IcMedal } from '../../assets/icons/ic_medal.svg';
import { ReactComponent as IcMenuBurger } from '../../assets/icons/ic_menu_burger.svg';
import { ReactComponent as IcMenuDots } from "../../assets/icons/ic_menu_dots.svg";
import { ReactComponent as IcMeterMarginCall } from "../../assets/icons/ic_meter_margin_call.svg";
import { ReactComponent as IcMeterStopOut } from "../../assets/icons/ic_meter_stop_out.svg";
import { ReactComponent as IcMicrosoft } from '../../assets/icons/ic_microsoft.svg';
import { ReactComponent as IcMinus } from '../../assets/icons/ic_minus.svg';
import { ReactComponent as IcMinusCircleWhite } from "../../assets/icons/ic_minus_circle_white.svg";
import { ReactComponent as IcMoveDown } from "../../assets/icons/ic_move_down.svg";
import { ReactComponent as IcMoveLeft } from '../../assets/icons/ic_move_left.svg';
import { ReactComponent as IcMoveRight } from "../../assets/icons/ic_move_right.svg";
import { ReactComponent as IcNasdaq } from '../../assets/icons/ic_nasdaq.svg';
import { ReactComponent as IcNegara } from "../../assets/icons/ic_negara.svg";
import { ReactComponent as IcNextRound } from '../../assets/icons/ic_next_round.svg';
import { ReactComponent as IcNgas } from '../../assets/icons/ic_ngas.svg';
import { ReactComponent as IcOverviewChart } from '../../assets/icons/ic_overview_chart.svg';
import { ReactComponent as IcOvo } from "../../assets/icons/ic_ovo.svg";
import { ReactComponent as IcPassport } from '../../assets/icons/ic_passport.svg';
import { ReactComponent as IcPaymentBadgeEuropeanBanks } from "../../assets/icons/ic_payment_badge_european_banks.svg";
import { ReactComponent as IcPaymentBadgeSslProtection } from "../../assets/icons/ic_payment_badge_ssl_protection.svg";
import { ReactComponent as IcPaymentBadgeThreeDSecure } from "../../assets/icons/ic_payment_badge_three_d_secure.svg";
import { ReactComponent as IcPaymentMethod } from "../../assets/icons/ic_payment_method.svg";
import { ReactComponent as IcPencil } from "../../assets/icons/ic_pencil.svg";
import { ReactComponent as IcPercent } from '../../assets/icons/ic_percent.svg';
import { ReactComponent as IcPermata } from "../../assets/icons/ic_permata.svg";
import { ReactComponent as IcPerson } from '../../assets/icons/ic_person.svg';
import { ReactComponent as IcPersonGroup } from '../../assets/icons/ic_person_group.svg';
import { ReactComponent as IcPix } from "../../assets/icons/ic_pix.svg";
import { ReactComponent as IcPixFull } from "../../assets/icons/ic_pix_full.svg";
import { ReactComponent as IcPlaceholder } from '../../assets/icons/ic_placeholder.svg';
import { ReactComponent as IcPlay } from "../../assets/icons/ic_play.svg";
import { ReactComponent as IcPlayRound } from "../../assets/icons/ic_play_round.svg";
import { ReactComponent as IcPlus } from '../../assets/icons/ic_plus.svg';
import { ReactComponent as IcPlusCircle } from '../../assets/icons/ic_plus_circle.svg';
import { ReactComponent as IcPlusCircleWhite } from "../../assets/icons/ic_plus_circle_white.svg";
import { ReactComponent as IcPortfolio } from '../../assets/icons/ic_portfolio.svg';
import { ReactComponent as IcPound } from '../../assets/icons/ic_pound.svg';
import { ReactComponent as IcPrice } from '../../assets/icons/ic_price.svg';
import { ReactComponent as IcQr } from '../../assets/icons/ic_qr.svg';
import { ReactComponent as IcQrCode } from "../../assets/icons/ic_qr_code.svg";
import { ReactComponent as IcQris } from "../../assets/icons/ic_qris.svg";
import { ReactComponent as IcQuestionMarkBubble } from '../../assets/icons/ic_question_mark_bubble.svg';
import { ReactComponent as IcRebuy } from '../../assets/icons/ic_rebuy.svg';
import { ReactComponent as IcRebuyColor } from '../../assets/icons/ic_rebuy_color.svg';
import { ReactComponent as IcRedo } from "../../assets/icons/ic_redo.svg";
import { ReactComponent as IcReduction } from '../../assets/icons/ic_reduction.svg';
import { ReactComponent as IcReferrals } from '../../assets/icons/ic_referrals.svg';
import { ReactComponent as IcRefill } from '../../assets/icons/ic_refill.svg';
import { ReactComponent as IcRefresh } from "../../assets/icons/ic_refresh.svg";
import { ReactComponent as IcRespawn } from '../../assets/icons/ic_respawn.svg';
import { ReactComponent as IcSAndP } from '../../assets/icons/ic_s_and_p.svg';
import { ReactComponent as IcSAndPShort } from '../../assets/icons/ic_s_and_p_short.svg';
import { ReactComponent as IcSafariShare } from '../../assets/icons/ic_safari_share.svg';
import { ReactComponent as IcSearch } from "../../assets/icons/ic_search.svg";
import { ReactComponent as IcSettings } from "../../assets/icons/ic_settings.svg";
import { ReactComponent as IcSharedDots } from '../../assets/icons/ic_share_dots.svg';
import { ReactComponent as IcShield } from '../../assets/icons/ic_shield.svg';
import { ReactComponent as IcShopeepay } from "../../assets/icons/ic_shopeepay.svg";
import { ReactComponent as IcSilverCircle } from '../../assets/icons/ic_silver_circle.svg';
import { ReactComponent as IcSquareArrowUpRight } from '../../assets/icons/ic_square_arrow_up_right.svg';
import { ReactComponent as IcStar } from "../../assets/icons/ic_star.svg";
import { ReactComponent as IcStarFilled } from "../../assets/icons/ic_star_filled.svg";
import { ReactComponent as IcStop } from '../../assets/icons/ic_stop.svg';
import { ReactComponent as IcStopwatch } from "../../assets/icons/ic_stopwatch.svg";
import { ReactComponent as IcSupport } from '../../assets/icons/ic_support.svg';
import { ReactComponent as IcTesla } from '../../assets/icons/ic_tesla.svg';
import { ReactComponent as IcTicket } from '../../assets/icons/ic_ticket.svg';
import { ReactComponent as IcTicketAdd } from '../../assets/icons/ic_ticket_add.svg';
import { ReactComponent as IcTicketCheck } from '../../assets/icons/ic_ticket_check.svg';
import { ReactComponent as IcTrades } from '../../assets/icons/ic_trades.svg';
import { ReactComponent as IcTransaction } from '../../assets/icons/ic_transaction.svg';
import { ReactComponent as IcTvBaseline } from "../../assets/icons/ic_tv_baseline.svg";
import { ReactComponent as IcTvHeikinAshi } from "../../assets/icons/ic_tv_heikin_ashi.svg";
import { ReactComponent as IcTvHighLow } from "../../assets/icons/ic_tv_high_low.svg";
import { ReactComponent as IcTvHollowCandles } from "../../assets/icons/ic_tv_hollow_candles.svg";
import { ReactComponent as IcUndo } from "../../assets/icons/ic_undo.svg";
import { ReactComponent as IcUnknownError } from "../../assets/icons/ic_unknown_error.svg";
import { ReactComponent as IcUp } from '../../assets/icons/ic_up.svg';
import { ReactComponent as IcUpThin } from '../../assets/icons/ic_up_thin.svg';
import { ReactComponent as IcUpdate } from '../../assets/icons/ic_update.svg';
import { ReactComponent as  IcUpMini } from '../../assets/icons/ic_up_mini.svg';
import { ReactComponent as IcUpi } from '../../assets/icons/ic_upi.svg';
import { ReactComponent as IcUsd } from '../../assets/icons/ic_usd.svg';
import { ReactComponent as IcUsdClear } from '../../assets/icons/ic_usd_clear.svg';
import { ReactComponent as IcWallet } from '../../assets/icons/ic_wallet.svg';
import { ReactComponent as IcWarning } from '../../assets/icons/ic_warning.svg';
import { ReactComponent as IcWarningRed } from '../../assets/icons/ic_warning_red.svg';
import { ReactComponent as IcWithdraw } from '../../assets/icons/ic_withdraw.svg';
import { ReactComponent as IcXCircle } from "../../assets/icons/ic_x_circle.svg";
import { ReactComponent as IcXCircleRed } from '../../assets/icons/ic_x_circle_red.svg';
import { ReactComponent as IcXMark } from '../../assets/icons/ic_x_mark.svg';
import { ReactComponent as IcXMarkThin } from '../../assets/icons/ic_x_mark_thin.svg';

const iconsComponents = {
    IcAlibaba,
    IcAlibabaCircle,
    IcAmazon,
    IcAppStoreBadge,
    IcApple,
    IcAppleCircle,
    IcArrowLeft,
    IcArrowRight,
    IcArrowRightLeft,
    IcAssetDefault,
    IcAttention,
    IcAttentionCircleWhite,
    IcBack,
    IcBank,
    IcBankCard,
    IcBankCardArrowRight,
    IcBell,
    IcBellFilled,
    IcBellPlus,
    IcBellPlusFilled,
    IcBitcoin,
    IcBnb,
    IcBonus,
    IcBonusStub,
    IcBonusTransaction,
    IcBookClosed,
    IcBookmark,
    IcBookmarkFilled,
    IcBrain,
    IcBrent,
    IcBriVa,
    IcBtc,
    IcCard,
    IcCashback,
    IcChainLink,
    IcChartBars,
    IcChartCandle,
    IcChartColumn,
    IcChartLine,
    IcChartMountain,
    IcChartStatistic,
    IcCheckCircle,
    IcCheckCircleBorder,
    IcCheckCircleThin,
    IcCheckMark,
    IcCheckMarkCircle,
    IcCheckMarkCircleGreen,
    IcCheckMarkShield,
    IcChevronDown,
    IcChevronLeft,
    IcChevronRight,
    IcChevronSliderDown,
    IcChevronSliderUp,
    IcCimb,
    IcCircleSlashed,
    IcCisco,
    IcCiscoCircle,
    IcCiti,
    IcClear,
    IcClock,
    IcClockBlackCircle,
    IcClose,
    IcClose16,
    IcCloseWhite,
    IcCoinStack,
    IcCoins,
    IcCollapse,
    IcCollectionCrypto,
    IcCollectionForex,
    IcCollectionIndices,
    IcCollectionMaterials,
    IcCollectionStocks,
    IcConnect,
    IcCopy,
    IcCountry,
    IcCoupon,
    IcCrypto,
    IcDana,
    IcDash,
    IcDateRange,
    IcDelete,
    IcDeleteBasket,
    IcDisconnect,
    IcDocCopy,
    IcDocument,
    IcDollar,
    IcDollarRefresh,
    IcDot,
    IcDowJones,
    IcDown,
    IcDownThin,
    IcDownMini,
    IcDrawingTools,
    IcEbay,
    IcEducation,
    IcEmptyPage,
    IcEnvelope,
    IcEnvelopeCheckmark,
    IcEth,
    IcEthereum,
    IcExclamationMarkCircle,
    IcExclamationMarkTriangle,
    IcExpand,
    IcEyeOff,
    IcEyeOn,
    IcFacebook,
    IcFingerprint,
    IcFlags,
    IcFlagsChfUsd,
    IcFlagsEurUsd,
    IcFlagsJpyEur,
    IcFlagsJpyUsd,
    IcFlagsUkUsd,
    IcForward,
    IcGas,
    IcGcash,
    IcGear,
    IcGearApp,
    IcGift,
    IcGoPay,
    IcGold,
    IcGoldCircle,
    IcGoogle,
    IcGooglePlayBadge,
    IcGrabber,
    IcGraduationCap,
    IcGrowth,
    IcHarpoonLeftRight,
    IcHelpCircle,
    IcHistory,
    IcHp,
    IcImps,
    IcIndicators,
    IcInfinity,
    IcInfo,
    IcInfoCircle,
    IcInfoFilled,
    IcKoalaIb,
    IcLineTool,
    IcLink,
    IcLinkaja,
    IcLock,
    IcLogoLetter,
    IcLots,
    IcLtc,
    IcManager,
    IcMandiri,
    IcMedal,
    IcMenuBurger,
    IcMenuDots,
    IcMeterMarginCall,
    IcMeterStopOut,
    IcMicrosoft,
    IcMinus,
    IcMinusCircleWhite,
    IcMoveDown,
    IcMoveLeft,
    IcMoveRight,
    IcNasdaq,
    IcNegara,
    IcNextRound,
    IcNgas,
    IcOverviewChart,
    IcOvo,
    IcPassport,
    IcPaymentBadgeEuropeanBanks,
    IcPaymentBadgeSslProtection,
    IcPaymentBadgeThreeDSecure,
    IcPaymentMethod,
    IcPencil,
    IcPercent,
    IcPermata,
    IcPerson,
    IcPersonGroup,
    IcPix,
    IcPixFull,
    IcPlaceholder,
    IcPlay,
    IcPlayRound,
    IcPlus,
    IcPlusCircle,
    IcPlusCircleWhite,
    IcPortfolio,
    IcPound,
    IcPrice,
    IcQr,
    IcQrCode,
    IcQris,
    IcQuestionMarkBubble,
    IcRebuy,
    IcRebuyColor,
    IcRedo,
    IcReduction,
    IcReferrals,
    IcRefill,
    IcRefresh,
    IcRespawn,
    IcSAndP,
    IcSAndPShort,
    IcSafariShare,
    IcSearch,
    IcSettings,
    IcSharedDots,
    IcShield,
    IcShopeepay,
    IcSilverCircle,
    IcSquareArrowUpRight,
    IcStar,
    IcStarFilled,
    IcStop,
    IcStopwatch,
    IcSupport,
    IcTesla,
    IcTicket,
    IcTicketAdd,
    IcTicketCheck,
    IcTrades,
    IcTransaction,
    IcTvBaseline,
    IcTvHeikinAshi,
    IcTvHighLow,
    IcTvHollowCandles,
    IcUndo,
    IcUnknownError,
    IcUp,
    IcUpThin,
    IcUpdate,
    IcUpMini,
    IcUpi,
    IcUsd,
    IcUsdClear,
    IcWallet,
    IcWarning,
    IcWarningRed,
    IcWithdraw,
    IcXCircle,
    IcXCircleRed,
    IcXMark,
    IcXMarkThin,
} as const;

export type TIconsNames = keyof typeof iconsComponents;

type IIconProps = IImgProps | IAssetIconsProps;

const BinIcon = memo<IIconProps>(({
                                      name,
                                      height = "1em",
                                      width = "1em",
                                      size,
                                      style = {},
                                      defaultIcon,
                                      ...iconProps
                                  }) => {
    if (!name) {
        return null;
    }
    if (!iconsComponents[name]) {
        if (defaultIcon && iconsComponents[defaultIcon]) {
            name = defaultIcon;
        } else {
            return <></>
        }
    }
    const Component = iconsComponents[name];
    return <Component height={height} width={width} {...iconProps as IAssetIconsProps} name={name}
                      style={{ fontSize: size || '1.5em', display: 'inline-block', lineHeight: 1.25, ...style }}/>
});

export default BinIcon;
